import { createI18n } from 'vue-i18n'
import ptBR from './pt-BR'
import es from './es'

const messages = {
  'pt-BR': ptBR,
  es
}

// Detectar idioma do navegador ou usar padrão do localStorage
function getBrowserLanguage(): string {
  const stored = localStorage.getItem('z3c-language')
  if (stored && messages[stored as keyof typeof messages]) {
    return stored
  }
  
  const browserLang = navigator.language.toLowerCase()
  
  // Mapear idiomas do navegador para nossos códigos
  if (browserLang.startsWith('pt-br') || browserLang === 'pt') {
    return 'pt-BR'
  }
  if (browserLang.startsWith('es')) {
    return 'es'
  }
  
  return 'pt-BR' // Padrão em português
}

export const i18n = createI18n({
  legacy: false,
  locale: getBrowserLanguage(),
  fallbackLocale: 'pt-BR',
  messages
})

export const availableLocales = [
  { code: 'pt-BR', name: 'Português', flag: '🇧🇷' },
  { code: 'es', name: 'Español', flag: '🇪🇸' }
]

export function setLanguage(locale: string) {
  i18n.global.locale.value = locale as any
  localStorage.setItem('z3c-language', locale)
  document.documentElement.lang = locale
}
